import styled from 'styled-components';

import { FlexColumn } from '@/styled/common';

export const ConversationContainer = styled(FlexColumn)`
  min-width: 320px;
  width: 100%;
  max-width: 100%;
  height: 100%;
  background-color: ${({ theme }) => theme.bg.main};
  flex-grow: 1;
  flex-shrink: 1;
`;
